export default {
  energy: "kWh",
  gas: "mmBTU",
  chilled_water: "ton-hours",
  steam: "lbs - steam",
  simulation: "kWh"
};
